<template>
  <div class="multiselect__base">
    <label
      v-if="labelInput"
      class="inline-block text-sm font-semibold text-grey p-0 mb-1"
    >
      {{ labelInput }}
    </label>
    <v-multiselect
      ref="multiselect"
      v-model="selected"
      v-bind="$attrs"
      label="text"
      track-by="value"
      :options="options"
      :show-labels="false"
      :multiple="isMultiple"
      :close-on-select="true"
      :placeholder="placeholder"
      :class="{'disabled-multiselect': $attrs.disabled}"
      @open="open"
      @close="close"
      @select="select"
      @remove="remove"
    >
      <template #caret="{ toggle }">
        <i
          class="multiselect__icon-dropdown"
          :class="{'disabled': $attrs.disabled}"
          @mousedown.prevent.stop="toggle"
        >
          <img
            width="16"
            :src="require('@/assets/shipo-sales-plan-arrow-down.svg')"
          >
        </i>
      </template>
    </v-multiselect>
  </div>
</template>

<script>

export default {
  props: {
    isMultiple: {
      type: Boolean,
      default: () => false
    },
    placeholder: {
      type: String,
      default: () => null
    },
    labelInput: {
      type: String,
      default: () => null
    },
    options: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      elOptions: null,
      parentOptions: null,
      selected: null
    }
  },
  methods: {
    getPosition() {

      const el = this.$refs.multiselect.$el
      const content = this.$refs.multiselect.$refs.list
      let top = 0
      let left = 0
      let width = 0
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop

      if (el.getBoundingClientRect().top + content.scrollHeight + 20 >= window.innerHeight) {
        top = el.getBoundingClientRect().top + el.clientHeight + scrollTop - content.scrollHeight
      } else {
        top = (el.getBoundingClientRect().top + scrollTop)
      }

      left = el.getBoundingClientRect().left
      width = el.offsetWidth >= 120 ? el.offsetWidth : 120

      return {
        left: ''.concat(left, 'px'),
        top: ''.concat(top + el.offsetHeight, 'px'),
        width: ''.concat(width, 'px')
      }
    },
    open() {
      this.elOptions = this.$refs.multiselect.$refs.list
      this.parentOptions = this.elOptions.parentNode
      const pos = this.getPosition()

      this.elOptions.style.left = pos.left
      this.elOptions.style.top = pos.top
      this.elOptions.style.minWidth = pos.width
      this.elOptions.style.zIndex = 40000

      document.body.appendChild(this.elOptions)
    },
    close() {
      this.elOptions.style.left = ""
      this.elOptions.style.top = ""
      this.elOptions.style.width = ""
      this.elOptions.style.zIndex = ""

      this.parentOptions.appendChild(this.elOptions)

      this.elOptions = null
      this.parentOptions = null
    },
    input(value) {
      this.selected = this.options.find(item => item.value === value.value)
    },
    select(selectedOption) {
      this.$emit('input', selectedOption.value)
    },
    remove() {
      this.selected = { text: '', value: '' }
      this.$emit('input', '')
    }
  }
}
</script>

<style lang="scss" scoped>

.multiselect__icon-dropdown.disabled {
  img {
    filter: grayscale(100%);
  }
}
</style>
